var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    fill: "white",
    viewBox: "0.5 0 24 24",
    enableBackground: "new 0.5 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,10.625h-1.375V8.391c0-0.68-0.268-1.334-0.748-1.818c-0.438-0.441-1.018-0.709-1.637-0.754v-2.24 c0-0.68-0.266-1.334-0.746-1.818C18.514,1.274,17.859,1,17.176,1H5.258C4.257,1,3.3,1.401,2.596,2.111 C1.893,2.822,1.5,3.782,1.5,4.781v14.438c0,0.998,0.393,1.958,1.096,2.668C3.3,22.599,4.257,23,5.258,23h14.3 c0.686,0,1.34-0.275,1.818-0.76c0.48-0.485,0.748-1.139,0.748-1.818v-2.464H23.5V10.625z M20.75,15.208h-3.514 c-0.313,0-0.594-0.117-0.789-0.3c-0.191-0.18-0.281-0.402-0.281-0.617c0-0.213,0.09-0.438,0.281-0.617 c0.195-0.183,0.477-0.299,0.789-0.299h2.139h1.375V15.208z M4.55,4.047C4.74,3.855,4.995,3.75,5.258,3.75h11.734v2.063H5.258 c-0.263,0-0.518-0.105-0.708-0.298c-0.19-0.192-0.3-0.456-0.3-0.733C4.25,4.503,4.36,4.239,4.55,4.047z M19.375,20.249H5.258 c-0.263,0-0.518-0.104-0.708-0.296c-0.19-0.192-0.3-0.457-0.3-0.734V8.424c0.325,0.091,0.664,0.139,1.008,0.139h14.117v2.063h-2.139 c-0.986,0-1.947,0.366-2.67,1.043c-0.725,0.68-1.15,1.622-1.15,2.623c0,1.002,0.426,1.944,1.15,2.625 c0.723,0.677,1.684,1.042,2.67,1.042h2.139V20.249z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.c102c9dc8e7c1bbaa182022b3d96058c.svg";
export { ForwardRef as ReactComponent };